module.exports = __webpack_public_path__ + "static/media/plus-button.37a29af0.png";